var __esDecorate = (this && this.__esDecorate) || function (ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
};
var __runInitializers = (this && this.__runInitializers) || function (thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
};
var __setFunctionName = (this && this.__setFunctionName) || function (f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
import { html, LitElement } from 'lit';
import { property, query } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { uniqueId } from 'lodash-es';
import styles from './sds-switcher-item.lit.scss';
import { sdsCustomElement } from '../utilities/custom-components';
/**
 * Control represents a switcher button
 *
 * @fires sds.switcher-item.changed - Event is fired when the state of this switcher is changed.
 * Event is of `CustomEvent` type with empty details.
 */
let SdsSwitcherItem = (() => {
    var _SdsSwitcherItem_value_accessor_storage, _SdsSwitcherItem_name_accessor_storage, _SdsSwitcherItem_checked_accessor_storage, _SdsSwitcherItem_disabled_accessor_storage, _SdsSwitcherItem_label_accessor_storage, _SdsSwitcherItem_tooltip_accessor_storage, _SdsSwitcherItem_icon_accessor_storage, _SdsSwitcherItem_description_accessor_storage, _SdsSwitcherItem__switcher_accessor_storage;
    let _classDecorators = [sdsCustomElement('sds-switcher-item')];
    let _classDescriptor;
    let _classExtraInitializers = [];
    let _classThis;
    let _classSuper = LitElement;
    let _value_decorators;
    let _value_initializers = [];
    let _value_extraInitializers = [];
    let _name_decorators;
    let _name_initializers = [];
    let _name_extraInitializers = [];
    let _checked_decorators;
    let _checked_initializers = [];
    let _checked_extraInitializers = [];
    let _disabled_decorators;
    let _disabled_initializers = [];
    let _disabled_extraInitializers = [];
    let _label_decorators;
    let _label_initializers = [];
    let _label_extraInitializers = [];
    let _tooltip_decorators;
    let _tooltip_initializers = [];
    let _tooltip_extraInitializers = [];
    let _icon_decorators;
    let _icon_initializers = [];
    let _icon_extraInitializers = [];
    let _description_decorators;
    let _description_initializers = [];
    let _description_extraInitializers = [];
    let __switcher_decorators;
    let __switcher_initializers = [];
    let __switcher_extraInitializers = [];
    var SdsSwitcherItem = _classThis = class extends _classSuper {
        constructor() {
            super(...arguments);
            _SdsSwitcherItem_value_accessor_storage.set(this, __runInitializers(this, _value_initializers, void 0));
            _SdsSwitcherItem_name_accessor_storage.set(this, (__runInitializers(this, _value_extraInitializers), __runInitializers(this, _name_initializers, void 0)));
            _SdsSwitcherItem_checked_accessor_storage.set(this, (__runInitializers(this, _name_extraInitializers), __runInitializers(this, _checked_initializers, false)));
            _SdsSwitcherItem_disabled_accessor_storage.set(this, (__runInitializers(this, _checked_extraInitializers), __runInitializers(this, _disabled_initializers, false)));
            _SdsSwitcherItem_label_accessor_storage.set(this, (__runInitializers(this, _disabled_extraInitializers), __runInitializers(this, _label_initializers, void 0)));
            _SdsSwitcherItem_tooltip_accessor_storage.set(this, (__runInitializers(this, _label_extraInitializers), __runInitializers(this, _tooltip_initializers, void 0)));
            _SdsSwitcherItem_icon_accessor_storage.set(this, (__runInitializers(this, _tooltip_extraInitializers), __runInitializers(this, _icon_initializers, void 0)));
            _SdsSwitcherItem_description_accessor_storage.set(this, (__runInitializers(this, _icon_extraInitializers), __runInitializers(this, _description_initializers, '')));
            _SdsSwitcherItem__switcher_accessor_storage.set(this, (__runInitializers(this, _description_extraInitializers), __runInitializers(this, __switcher_initializers, void 0)));
            this._unique = (__runInitializers(this, __switcher_extraInitializers), uniqueId('sds-switcher-item'));
            this.handleKeyDown = (event) => {
                switch (event.code) {
                    case 'Enter':
                    case 'NumpadEnter':
                        event.preventDefault();
                        this.handleChange();
                }
            };
        }
        /**
         * Value that this switcher represents.
         * @attr
         */
        get value() { return __classPrivateFieldGet(this, _SdsSwitcherItem_value_accessor_storage, "f"); }
        set value(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_value_accessor_storage, value, "f"); }
        /**
         * Name of this switcher.
         * @attr
         */
        get name() { return __classPrivateFieldGet(this, _SdsSwitcherItem_name_accessor_storage, "f"); }
        set name(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_name_accessor_storage, value, "f"); }
        /**
         * State of switcher.
         * @attr
         */
        get checked() { return __classPrivateFieldGet(this, _SdsSwitcherItem_checked_accessor_storage, "f"); }
        set checked(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_checked_accessor_storage, value, "f"); }
        /**
         * True if this switcher is disabled.
         * @attr
         */
        get disabled() { return __classPrivateFieldGet(this, _SdsSwitcherItem_disabled_accessor_storage, "f"); }
        set disabled(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_disabled_accessor_storage, value, "f"); }
        /**
         * Label of the switcher.
         * @attr
         */
        get label() { return __classPrivateFieldGet(this, _SdsSwitcherItem_label_accessor_storage, "f"); }
        set label(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_label_accessor_storage, value, "f"); }
        /**
         * Label of the switcher.
         * @attr
         */
        get tooltip() { return __classPrivateFieldGet(this, _SdsSwitcherItem_tooltip_accessor_storage, "f"); }
        set tooltip(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_tooltip_accessor_storage, value, "f"); }
        /**
         * Icon of the switcher.
         * @attr
         */
        get icon() { return __classPrivateFieldGet(this, _SdsSwitcherItem_icon_accessor_storage, "f"); }
        set icon(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_icon_accessor_storage, value, "f"); }
        /**
         * Description of the switcher
         * @attr
         */
        get description() { return __classPrivateFieldGet(this, _SdsSwitcherItem_description_accessor_storage, "f"); }
        set description(value) { __classPrivateFieldSet(this, _SdsSwitcherItem_description_accessor_storage, value, "f"); }
        get _switcher() { return __classPrivateFieldGet(this, _SdsSwitcherItem__switcher_accessor_storage, "f"); }
        set _switcher(value) { __classPrivateFieldSet(this, _SdsSwitcherItem__switcher_accessor_storage, value, "f"); }
        updated() {
            this._switcher.checked = this.checked;
        }
        render() {
            return html `
            <label class="${this.getClasses()}" part="sds-switcher-item" for="${this._unique}">
                <input
                    tabindex="0"
                    class="sds-switcher-item__input"
                    type="radio"
                    id="${this._unique}"
                    ?checked="${this.checked}"
                    ?disabled="${this.disabled}"
                    value="${this.value}"
                    @change="${() => this.handleChange()}"
                    @keydown="${(e) => this.handleKeyDown(e)}"
                />
                ${this.addLabelIfActivated()} ${this.addOnlyIconIfActivated()}
                ${this.addDescriptionIfActivated()}
            </label>
        `;
        }
        addEventListener(type, listener, options) {
            super.addEventListener(type, listener, options);
        }
        willUpdate(changedProperties) {
            if (changedProperties.has('name')) {
                this._switcher.name = this.name;
            }
        }
        addIconIfActivated() {
            if (this.icon) {
                return html `<sds-icon size="16" name="${this.icon}"></sds-icon>`;
            }
        }
        addOnlyIconIfActivated() {
            if (this.icon && !this.label) {
                if (this.tooltip) {
                    return html `
                    <sds-tooltip basic position="up" style="width: 100%; height: 100%;">
                        <div class="sds-switcher-item__icon-container" slot="trigger">
                            <sds-icon
                                size="${this.parentElement.small ? 16 : 24}"
                                name="${this.icon}"
                            ></sds-icon>
                        </div>
                        <div slot="text">${this.tooltip}</div>
                    </sds-tooltip>
                `;
                }
                else {
                    return html `<sds-icon
                    size="${this.parentElement.small ? 16 : 24}"
                    name="${this.icon}"
                ></sds-icon>`;
                }
            }
        }
        addLabelIfActivated() {
            return (this.label &&
                html ` ${this.icon
                    ? html `<sds-clipped-text basic part="sds-clipped-text" text="${this.label}"
                      >${this.addIconIfActivated()}</sds-clipped-text
                  >`
                    : html `<sds-clipped-text
                      basic
                      part="sds-clipped-text"
                      text="${this.label}"
                  ></sds-clipped-text>`}`);
        }
        addDescriptionIfActivated() {
            if (this.description) {
                return html ` <div class="sds-switcher-item__description">
                <sds-clipped-text basic text="${this.description}"></sds-clipped-text>
            </div>`;
            }
        }
        handleChange() {
            this.checked = this._switcher.checked;
            const changed = new CustomEvent(SdsSwitcherItem.CHANGED_EVENT, {
                bubbles: false,
                composed: false,
            });
            this.dispatchEvent(changed);
        }
        getClasses() {
            return classMap({
                'sds-switcher-item': true,
                'sds-switcher-item--checked': this.checked,
                'sds-switcher-item--disabled': this.disabled,
                'sds-switcher-item--with-description': this.description,
                'sds-switcher-item--small': this.parentElement.small,
            });
        }
    };
    _SdsSwitcherItem_value_accessor_storage = new WeakMap();
    _SdsSwitcherItem_name_accessor_storage = new WeakMap();
    _SdsSwitcherItem_checked_accessor_storage = new WeakMap();
    _SdsSwitcherItem_disabled_accessor_storage = new WeakMap();
    _SdsSwitcherItem_label_accessor_storage = new WeakMap();
    _SdsSwitcherItem_tooltip_accessor_storage = new WeakMap();
    _SdsSwitcherItem_icon_accessor_storage = new WeakMap();
    _SdsSwitcherItem_description_accessor_storage = new WeakMap();
    _SdsSwitcherItem__switcher_accessor_storage = new WeakMap();
    __setFunctionName(_classThis, "SdsSwitcherItem");
    (() => {
        var _a;
        const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create((_a = _classSuper[Symbol.metadata]) !== null && _a !== void 0 ? _a : null) : void 0;
        _value_decorators = [property({ type: String })];
        _name_decorators = [property({ type: String })];
        _checked_decorators = [property({ type: Boolean, reflect: true })];
        _disabled_decorators = [property({ type: Boolean })];
        _label_decorators = [property({ type: String })];
        _tooltip_decorators = [property({ type: String })];
        _icon_decorators = [property({ type: String })];
        _description_decorators = [property({ type: String })];
        __switcher_decorators = [query('input[type=radio]')];
        __esDecorate(_classThis, null, _value_decorators, { kind: "accessor", name: "value", static: false, private: false, access: { has: obj => "value" in obj, get: obj => obj.value, set: (obj, value) => { obj.value = value; } }, metadata: _metadata }, _value_initializers, _value_extraInitializers);
        __esDecorate(_classThis, null, _name_decorators, { kind: "accessor", name: "name", static: false, private: false, access: { has: obj => "name" in obj, get: obj => obj.name, set: (obj, value) => { obj.name = value; } }, metadata: _metadata }, _name_initializers, _name_extraInitializers);
        __esDecorate(_classThis, null, _checked_decorators, { kind: "accessor", name: "checked", static: false, private: false, access: { has: obj => "checked" in obj, get: obj => obj.checked, set: (obj, value) => { obj.checked = value; } }, metadata: _metadata }, _checked_initializers, _checked_extraInitializers);
        __esDecorate(_classThis, null, _disabled_decorators, { kind: "accessor", name: "disabled", static: false, private: false, access: { has: obj => "disabled" in obj, get: obj => obj.disabled, set: (obj, value) => { obj.disabled = value; } }, metadata: _metadata }, _disabled_initializers, _disabled_extraInitializers);
        __esDecorate(_classThis, null, _label_decorators, { kind: "accessor", name: "label", static: false, private: false, access: { has: obj => "label" in obj, get: obj => obj.label, set: (obj, value) => { obj.label = value; } }, metadata: _metadata }, _label_initializers, _label_extraInitializers);
        __esDecorate(_classThis, null, _tooltip_decorators, { kind: "accessor", name: "tooltip", static: false, private: false, access: { has: obj => "tooltip" in obj, get: obj => obj.tooltip, set: (obj, value) => { obj.tooltip = value; } }, metadata: _metadata }, _tooltip_initializers, _tooltip_extraInitializers);
        __esDecorate(_classThis, null, _icon_decorators, { kind: "accessor", name: "icon", static: false, private: false, access: { has: obj => "icon" in obj, get: obj => obj.icon, set: (obj, value) => { obj.icon = value; } }, metadata: _metadata }, _icon_initializers, _icon_extraInitializers);
        __esDecorate(_classThis, null, _description_decorators, { kind: "accessor", name: "description", static: false, private: false, access: { has: obj => "description" in obj, get: obj => obj.description, set: (obj, value) => { obj.description = value; } }, metadata: _metadata }, _description_initializers, _description_extraInitializers);
        __esDecorate(_classThis, null, __switcher_decorators, { kind: "accessor", name: "_switcher", static: false, private: false, access: { has: obj => "_switcher" in obj, get: obj => obj._switcher, set: (obj, value) => { obj._switcher = value; } }, metadata: _metadata }, __switcher_initializers, __switcher_extraInitializers);
        __esDecorate(null, _classDescriptor = { value: _classThis }, _classDecorators, { kind: "class", name: _classThis.name, metadata: _metadata }, null, _classExtraInitializers);
        SdsSwitcherItem = _classThis = _classDescriptor.value;
        if (_metadata) Object.defineProperty(_classThis, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
    })();
    _classThis.CHANGED_EVENT = 'sds.switcher-item.changed';
    _classThis.styles = styles;
    (() => {
        __runInitializers(_classThis, _classExtraInitializers);
    })();
    return SdsSwitcherItem = _classThis;
})();
export { SdsSwitcherItem };
